import React from "react";
import { useCardPreview } from "../../contexts/CardPreviewContext";

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const PreviewSafeAnchor: React.FC<AnchorProps> = ({
  children,
  className,
  style,
  title,
  dir,
  ...anchorProps
}) => {
  const isPreview = useCardPreview();

  if (isPreview) {
    return (
      <span className={className} style={style} title={title} dir={dir}>
        {children}
      </span>
    );
  }

  return (
    <a
      {...anchorProps}
      className={className}
      style={style}
      title={title}
      dir={dir}
    >
      {children}
    </a>
  );
};

export default PreviewSafeAnchor;
